import { useLocation, useParams } from 'react-router-dom'

import { NotFound } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { getDatoLocale } from 'modules/onboarding/lib/datoLocale'
import { countryCode } from 'modules/marketplace_modules/components/utils/countryCode'
import { useGetDatoModules } from 'modules/marketplace_modules/hooks/useGetDatoModules'
import ModulesDetailRevamp from 'modules/marketplace_modules/pages/ModulesDetailRevamp'

const ModulesDetailTemplate = () => {
  const { id: slug } = useParams()
  const { pathname } = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const upsellOrigin = queryParams.get('upsell_origin')
  const from = queryParams.get('from')
  const {
    company,
    access: { locale: user_locale },
  } = useCurrentSession()

  const datoFormatLocale = getDatoLocale(user_locale)
  const countryCodeForCompany = countryCode(company.legalEntities[0]?.country || '')

  const { data: moduleData, loading } = useGetDatoModules({
    locale: datoFormatLocale,
    slug: slug,
    countryCode: countryCodeForCompany,
  })
  const module = moduleData.at(0)

  useEffect(() => {
    if (module?.chargebeeModuleName) {
      track(trackingEvents.marketplaceModules.visitModuleDetailPage, {
        module_slug: slug,
        upsell_origin: upsellOrigin,
        origin: from || upsellOrigin,
      })
    }
  }, [from, pathname, upsellOrigin, slug, module?.chargebeeModuleName])

  if (loading) return <Loading />

  if (!module) {
    return (
      <NotFound
        title={i18n.t('errors.page_not_found.title')}
        description={i18n.t('errors.page_not_found.description')}
      />
    )
  }

  return <ModulesDetailRevamp />
}

export default ModulesDetailTemplate
